import React from "react";
import { FormGroup } from "reactstrap";
import { P } from "../../AbstractElements";
import itinerary from "../../assets/images/Fasilkom Itenary Cabil 2025.png";
import ImageWithLightbox from "./ImageWithLightbox";
import { Controller } from "react-hook-form";
import { InputField } from "../../CommonElements";

const PartOne = ({ control, watch }) => {
  return (
    <div>
      <div className="mb-4" style={{ textAlign: "left"}}>
        <P>Salam Cabilnya Fasilkom ke Bajo!
          <br/>
          <br/>
          Sebelum berangkat ke Labuan Bajo, mohon kiranya bapak/ibu dapat  melengkapi data diri  dan memeriksa kembali isian/informasi yang telah terisi. Kami juga membutuhkan informasi tentang kondisi Bapak/ibu agar perjalanan kita nanti tetap aman dan asyik.
          <br/>
          <br/>
          Kami menunggu konfirmasi isian bapak/ibu paling lambat hari Selasa tanggal 20 Mei 2025.</P>
          <br />
          <br />
          <P>
            Contact Person
            <br />
            <br />
            <strong>Aisyah</strong> <a href="https://wa.me/+6282114068585">0821-1406-8585</a>
            <br />
            <strong>Juwita</strong> <a href="https://wa.me/+6285694166120">0856-9416-6120</a>
            <br />
            <strong>Amala</strong> <a href="https://wa.me/+6282231999681">0822-3199-9681</a>
            <br />
            <strong>Dede</strong> <a href="https://wa.me/+6287820777878">0878-2077-7878</a>
            <br />
            <strong>Tri</strong> <a href="https://wa.me/+6281317483364">0813-0748-3364</a>
          </P>
      </div>
      
      <div className="text-center mb-4">
        <ImageWithLightbox 
          src={itinerary} 
          alt="Itinerary"
          style={{
            margin: "auto", 
            width: "100%", 
            maxWidth: "600px", 
            height: "auto", 
            display: "block"
          }} 
        />
      </div>

      <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
        <label className="bg-transparent">
          Preview aktivitas hari ke-3 yang telah Anda pilih sebelumnya
        </label>
        <P>{watch("wisata")}</P>
        {/* <Controller
          name="wisata"
          control={control}
          rules={{ required: "Harap tidak mengubah isi" }}
          render={({field, fieldState}) => (
            <InputField
              label="Preview lokasi wisata yang telah Anda pilih sebelumnya"
              className="mb-3"
              fieldState={fieldState}
              {...field}
              isRequired
              disabled
            />
          )}
        /> */}
      </FormGroup>
    </div>
  );
};

export default PartOne;